module.exports = __webpack_public_path__ + "img/logo.5fe90661.png";